import { defineMessages } from 'react-intl';

export default defineMessages({
    ExcessTableHeader: {
        id: 'cep.components.SgExcessChangesTable.ExcessTableHeader',
        defaultMessage: 'As a result of today\'s changes your {compulsory} accidental damage excess will change to: £{excess}'
    },
    ExcessTableHeaderFT: {
        id: 'cep.components.SgExcessChangesTable.ExcessTableHeaderFT',
        defaultMessage: 'As a result of today\'s changes your Fire & Theft excess will change to: £{excess}'
    },
    VoluntaryExcess: {
        id: 'cep.components.SgExcessChangesTable.VoluntaryExcess',
        defaultMessage: 'Voluntary Excess'
    },
    CompulsoryExcess: {
        id: 'cep.components.SgExcessChangesTable.CompulsoryExcess',
        defaultMessage: 'Compulsory Excess'
    },
    TotalExcess: {
        id: 'cep.components.SgExcessChangesTable.TotalExcess',
        defaultMessage: 'Total Excess'
    },
    Header: {
        id: 'cep.components.SgExcessChangesTable.Header',
        defaultMessage: 'As a result of today\'s changes your accidental damage excess will change to: '
    }
});
